import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Login from './Login';

import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { config, passport, checkout } from '@imtbl/sdk';

const PUBLISHABLE_KEY = 'pk_imapik-mLilTmypub_2VLS7Tv0V'; // Replace with your Publishable Key from the Immutable Hub
//const CLIENT_ID = 'OTNGWZI7RM1dYuRzQ4ubGiUfWPto49xh';
const CLIENT_ID = 'tF6qZw9EcZHLTPb7VYWnca9jEdDGFnQe';
//const CLIENT_ID = 'tF6qZw9EcZHLTPb7VYWnca9jEdDGFnQe';
const currentDomain = window.location.origin;

const baseConfig ={
  environment: config.Environment.PRODUCTION,
  publishableKey: PUBLISHABLE_KEY,
}


const passportInstance = new passport.Passport({
  baseConfig: baseConfig,
  clientId: CLIENT_ID,
  redirectUri: `${currentDomain}/redirect`,
  logoutRedirectUri: `${currentDomain}/logout`,
  audience: 'platform_api',
  scope: 'openid offline_access email transact',
});

const checkoutSDK = new checkout.Checkout({
  baseConfig,
  passport: passportInstance,
  bridge:{enable:true},
  swap:{enable:true}
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <App passportInstance={passportInstance} checkoutSDK={checkoutSDK} />,
  },
  {
    path: "/redirect",
    element: <Login passportInstance={passportInstance} />,
  }
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
